export default {
    text: {
        SHOW_DIFFERENCE: 'Pokaż różnice',
        HIDE_DIFFERENCE: 'Ukryj różnice',
    },
};
